import icon1 from '../images/service/icon/Home.png'
import icon2 from '../images/service/icon/Site.png'
import icon3 from '../images/service/icon/Blueprint.png'
import icon4 from '../images/service/icon/Plan.png'
import icon5 from '../images/service/icon-2/1.svg'
import icon6 from '../images/service/icon-2/2.svg'
import icon7 from '../images/service/icon-2/3.svg'
import icon8 from '../images/service/icon-2/4.svg'
import icon9 from '../images/service/icon-2/5.svg'
import icon10 from '../images/service/icon-2/6.svg'
import icon11 from '../images/service/icon/town1.svg'
import icon12 from '../images/service/icon/urban-planning1.svg'
import icon13 from '../images/service/icon/social-care1.svg'
import icon14 from '../images/service/icon/planning1.svg'
import icon15 from '../images/service/icon-4/excavator.svg'
import icon16 from '../images/service/icon-4/contractor.svg'
import icon17 from '../images/service/icon-4/excavator.svg'
import icon18 from '../images/service/icon-4/property.svg'

import sSimg1 from '../images/service-single/1.jpg'
import sSimg2 from '../images/service-single/2.jpg'
import sSimg3 from '../images/service-single/3.jpg'
import sSimg4 from '../images/service-single/4.jpg'
import sSimg5 from '../images/service-single/5.jpg'
import sSimg6 from '../images/service-single/6.jpg'
import sSimg7 from '../images/service-single/7.jpg'
import sSimg8 from '../images/service-single/8.jpg'
import sSimg9 from '../images/service-single/9.jpg'
import sSimg10 from '../images/service-single/10.jpg'
import sSimg11 from '../images/service-single/11.jpg'
import sSimg12 from '../images/service-single/12.jpg'
import sSimg13 from '../images/service-single/13.jpg'
import sSimg14 from '../images/service-single/14.jpg'
import sSimg15 from '../images/service-single/15.jpg'
import sSimg16 from '../images/service-single/16.jpg'
import sSimg17 from '../images/service-single/17.jpg'
import sSimg18 from '../images/service-single/18.jpg'


const Services = [
   // {
   //    Id: '01',
   //    Icon: icon1,
   //    SImg: sSimg1,
   //    title: 'Custom Solutions',
   //    Subtitle: 'Custom Solutions',
   //    slug: 'Custom-Solutions',
   //    description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   // },
   // {
   //    Id: '02',
   //    Icon: icon2,
   //    SImg: sSimg2,
   //    title: 'Furniture & Decor',
   //    Subtitle: 'Furniture & Decor',
   //    slug: 'Furniture-Decor',
   //    description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   // },
   // {
   //    Id: '03',
   //    Icon: icon3,
   //    SImg: sSimg3,
   //    title: 'Interior Design',
   //    Subtitle: 'Interior Design',
   //    slug: 'Interior-Design',
   //    description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   // },
   // {
   //    Id: '04',
   //    Icon: icon4,
   //    SImg: sSimg4,
   //    title: 'Design & Planning',
   //    Subtitle: 'Design & Planning',
   //    slug: 'Design-Planning',
   //    description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   // },
   {
      Id: '01',
      Icon: icon1,
      SImg: sSimg1,
      title: 'Home Build',
      Subtitle: 'Home Build',
      slug: 'home-build',
      description: 'Complete residential home builds delivered with quality craftsmanship, modern design, and end-to-end management.',
   },
   {
      Id: '02',
      Icon: icon2,
      SImg: sSimg2,
      title: 'Site Prep',
      Subtitle: 'Site Prep',
      slug: 'site-prep',
      description: 'Professional site preparation including land assessment, leveling, and groundwork to ensure a strong foundation.',
   },
   {
      Id: '03',
      Icon: icon3,
      SImg: sSimg3,
      title: 'Plan Design',
      Subtitle: 'Plan Design',
      slug: 'plan-design',
      description: 'Custom home plans designed to suit your land, lifestyle, and local council requirements across Australia.',
   },
   {
      Id: '04',
      Icon: icon4,
      SImg: sSimg4,
      title: 'Build Service',
      Subtitle: 'Build Service',
      slug: 'build-service',
      description: 'Reliable construction services delivering structurally sound, energy-efficient homes built to Australian standards.',
   },

   {
      Id: '05',
      Icon: icon5,
      SImg: sSimg5,
      title: 'Design & Planning',
      Subtitle: 'Design & Planning',
      slug: 'Design-Planning-2',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '06',
      Icon: icon6,
      SImg: sSimg6,
      title: 'Interior Design',
      Subtitle: 'Interior Design',
      slug: 'InteriorDesign-2',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '07',
      Icon: icon7,
      SImg: sSimg7,
      title: 'Custom Solutions',
      Subtitle: 'Custom Solutions',
      slug: 'Custom-Solutions-2',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '08',
      Icon: icon8,
      SImg: sSimg8,
      title: 'Architectural Design',
      Subtitle: 'Architectural Design',
      slug: 'Architectural-Design',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '09',
      Icon: icon9,
      SImg: sSimg9,
      title: 'Design & Planning',
      Subtitle: 'Design & Planning',
      slug: 'DesignPlanning21',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '10',
      Icon: icon10,
      SImg: sSimg10,
      title: 'Power Managemnet',
      Subtitle: 'Power Managemnet',
      slug: 'Power-Managemnet22',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },

   {
      Id: '11',
      Icon: icon11,
      SImg: sSimg11,
      title: 'Urban Design',
      Subtitle: 'Urban Design',
      slug: 'Power-Managemnet23',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '12',
      Icon: icon12,
      SImg: sSimg12,
      title: 'Environmental Planning',
      Subtitle: 'Environmental Planning',
      slug: 'Power-Managemnet24',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '13',
      Icon: icon13,
      SImg: sSimg13,
      title: 'Community Engagement',
      Subtitle: 'Community Engagement',
      slug: 'Power-Managemnet25',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '14',
      Icon: icon14,
      SImg: sSimg14,
      title: 'Master Planning',
      Subtitle: 'Master Planning',
      slug: 'Master-Planning',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '15',
      Icon: icon15,
      SImg: sSimg15,
      title: 'Custom Solutions',
      Subtitle: 'Master Planning',
      slug: 'Master-Planning15',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '16',
      Icon: icon16,
      SImg: sSimg16,
      title: 'House Renovation',
      Subtitle: 'Master Planning',
      slug: 'Master-Planning16',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '17',
      Icon: icon17,
      SImg: sSimg17,
      title: 'General Contractor',
      Subtitle: 'Master Planning',
      slug: 'Master-Planning17',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },
   {
      Id: '18',
      Icon: icon18,
      SImg: sSimg18,
      title: 'City Landmarks',
      Subtitle: 'Master Planning',
      slug: 'Master-Planning18',
      description: 'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
   },


]

export default Services;